module.exports = __webpack_public_path__ + "img/terminated.90e8bdef.gif";